export default __webpack_public_path__ + "static/media/blog.74e74233.svg";